import React from "react";
import { PhoneCall, Mail, Instagram, Linkedin, Facebook } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="hob-footer">
      <div className="hob-footer-top">
        {/* Logo */}
        <div className="hob-footer-logo">
          <span className="hob-footer-text">The Tiny Therapist</span>
        </div>

        {/* Links */}
        <div className="hob-footer-links">
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/")}
            style={{ cursor: "pointer" }}
          >
            Home
          </span>
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/about")}
            style={{ cursor: "pointer" }}
          >
            About Us
          </span>
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/contact")}
            style={{ cursor: "pointer" }}
          >
            Contact Us
          </span>
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/privacy-note")}
            style={{ cursor: "pointer" }}
          >
            Privacy Note
          </span>
        </div>

        {/* Contact Info & Socials */}
        <div className="hob-footer-contact">
          <p className="hob-footer-link"><strong>Working Hours:</strong> 10am to 8pm</p>
          <p className="hob-footer-link"> <strong>Email:</strong> Khandolrutika@gmail.com</p>
          {/* <div className="hob-footer-socials">
            <Instagram size={20} onClick={() => window.open("https://instagram.com/", "_blank")} style={{ cursor: 'pointer' }} />
            <Facebook size={20} onClick={() => window.open("https://facebook.com/", "_blank")} style={{ cursor: 'pointer' }} />
            <Linkedin size={20} onClick={() => window.open("https://linkedin.com/", "_blank")} style={{ cursor: 'pointer' }} />
          </div> */}
        </div>
      </div>

      <div className="hob-footer-bottom">
        <p className="hob-footer-copyright">
          &copy; {new Date().getFullYear()} {" "}
          <a href="https://100billiontech.com/ownership" target="_blank" rel="noreferrer">
            copy-right-reserved
          </a>, Designed by {" "}
          <a href="https://100billiontech.com/" target="_blank" rel="noreferrer">
            100Billion Tech
          </a>.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
